import React from "react";
import { ShieldCheck, Truck, Heart, Headphones, Award, RotateCcw } from "lucide-react";
import { useLang } from "../store";

export default function Reviews() {
  const { lang } = useLang();
  const isEs = lang === "es";

  const promises = [
    {
      Icon: Award,
      title_es: "Calidad garantizada",
      title_en: "Quality guaranteed",
      desc_es: "Materiales premium probados uno a uno antes de salir del almacén.",
      desc_en: "Premium materials tested one by one before leaving our warehouse.",
      bg: "#FFCC00",
    },
    {
      Icon: Truck,
      title_es: "Envío en 24-48h",
      title_en: "24-48h shipping",
      desc_es: "Desde nuestro almacén en España. Sin esperas eternas.",
      desc_en: "From our warehouse in Spain. No endless waits.",
      bg: "#FF3D7F",
    },
    {
      Icon: RotateCcw,
      title_es: "Devolución 30 días",
      title_en: "30-day returns",
      desc_es: "Si no te convence, te devolvemos el dinero sin preguntas.",
      desc_en: "If you don't love it, money back with no questions.",
      bg: "#1FB6FF",
    },
    {
      Icon: ShieldCheck,
      title_es: "Pago 100% seguro",
      title_en: "100% secure payment",
      desc_es: "Stripe encripta cada transacción. Tus datos nunca pasan por nosotros.",
      desc_en: "Stripe encrypts every transaction. Your data never touches us.",
      bg: "#9BE800",
    },
    {
      Icon: Headphones,
      title_es: "Atención directa",
      title_en: "Direct support",
      desc_es: "Te respondemos en menos de 24h por email o WhatsApp.",
      desc_en: "We reply within 24h by email or WhatsApp.",
      bg: "#8B5CF6",
    },
    {
      Icon: Heart,
      title_es: "Marca española",
      title_en: "Spanish brand",
      desc_es: "Pequeña empresa que pone cuidado en cada pedido. Cada compra importa.",
      desc_en: "Small business that puts care into every order. Every purchase matters.",
      bg: "#FF7A1A",
    },
  ];

  return (
    <section
      id="reviews"
      className="bg-[#FAF9F6] border-b-[3px] border-[#0C0A09]"
      data-testid="trust-section"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="nb-badge">
            {isEs ? "Nuestro compromiso" : "Our commitment"}
          </span>
          <h2 className="font-display text-5xl md:text-7xl leading-none tracking-tight mt-4">
            {isEs ? "Confiamos en nuestro trabajo." : "We trust our work."}
          </h2>
          <p className="mt-5 text-base md:text-lg font-medium leading-relaxed">
            {isEs
              ? "No te pedimos que confíes a ciegas. Por eso te respaldamos con garantías reales en cada pedido."
              : "We don't ask you to trust blindly. That's why every order comes with real guarantees."}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {promises.map(({ Icon, title_es, title_en, desc_es, desc_en, bg }) => (
            <div
              key={title_en}
              className="bg-white border-[3px] border-[#0C0A09] shadow-[6px_6px_0_0_#0C0A09] p-6 hover:-translate-y-1 hover:shadow-[8px_8px_0_0_#0C0A09] transition-all"
              data-testid={`trust-card-${title_en.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div
                className="w-14 h-14 rounded-full border-[3px] border-[#0C0A09] flex items-center justify-center mb-4"
                style={{ background: bg }}
              >
                <Icon size={22} strokeWidth={2.75} />
              </div>
              <h3 className="font-display text-2xl leading-none mb-2">
                {isEs ? title_es : title_en}
              </h3>
              <p className="text-sm font-medium leading-relaxed opacity-80">
                {isEs ? desc_es : desc_en}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom contact strip */}
        <div className="mt-12 bg-[#0C0A09] text-white border-[3px] border-[#0C0A09] p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#9BE800] mb-1">
              {isEs ? "¿Alguna duda?" : "Any question?"}
            </div>
            <div className="font-display text-2xl md:text-3xl leading-tight">
              {isEs ? "Escríbenos antes de comprar." : "Write to us before buying."}
            </div>
          </div>
          <a
            href="mailto:armanini091@gmail.com"
            data-testid="trust-contact-btn"
            className="inline-flex items-center gap-2 bg-[#9BE800] text-[#0C0A09] border-[3px] border-[#0C0A09] px-6 py-3 font-bold text-sm uppercase tracking-widest hover:-translate-y-0.5 transition-transform"
          >
            {isEs ? "Contactar" : "Contact us"} →
          </a>
        </div>
      </div>
    </section>
  );
}
